<template>
    <form data-vv-scope="address">
        <div :class="classForDOM.parent">
            <div :class="classForDOM.block">
                <MultiselectCustom endpoint="common/citizenship/"
                                   :disabled="disabled"
                                   @selected="setIfSelectedKazakhstan"
                                   :placeholder="`${ $t('county') }${ required ? '*' : '' }`"
                                   v-validate="'required'"
                                   v-model="address.country"
                                   name="country"/>
<!--                <ValidateText field="country" scope="address" :error="errors"/>-->
                <span
                    class="text-danger w-full text-sm ml-1"
                    v-show="address_errors.indexOf('country') >= 0"
                >{{ $t("validation_required") }}</span
                >
            </div>
            <template v-if="select_kazakhstan">
                <div :class="classForDOM.block">
                    <MultiselectCustom endpoint="common/address-classifiers/?address_element_type=1"
                                       :disabled="!address.country || disabled"
                                       @selected="clearDataForRegion"
                                       v-validate="'required'"
                                       :placeholder="`${ $t('region') }*`"
                                       v-model="address.region"
                                       name="region"/>
<!--                    <ValidateText field="region" scope="address" :error="errors"/>-->
                    <span
                        class="text-danger w-full text-sm ml-1"
                        v-show="address_errors.indexOf('region') >= 0"
                    >{{ $t("validation_required") }}</span
                    >
                </div>
                <div :class="classForDOM.block">
                    <MultiselectCustom :endpoint="`common/address-classifiers/?address_element_type=2&region=${address.region?address.region.uid:address.region}`"
                                       @selected="clearDataForDistrict"
                                       :disabled="!address.region || disabled"
                                       :placeholder="`${ $t('district') }`"
                                       v-model="address.district"
                                       name="district"/>
                </div>
                <div :class="classForDOM.block">
                    <MultiselectCustom :endpoint="`common/address-classifiers/?address_element_type=4&district=${address.district.uid}`"
                                       @selected="clearDataForLocality"
                                       :disabled="!address.district || disabled"
                                       :placeholder="`${ $t('locality') }`"
                                       v-model="address.locality"
                                       name="locality"/>
                </div>
                <div :class="classForDOM.block">
                    <MultiselectCustom :endpoint="getEndpointForGetCity"
                                       :disabled="!address.region || disabled"
                                       @selected="clearDataCity"
                                       :placeholder="`${ $t('city') }`"
                                       v-model="address.city"
                                       name="city"/>
                </div>
            </template>
            <template v-else>
                <div :class="classForDOM.block">
                    <vs-input :label-placeholder="`${ $t('address_city_text') }`"
                              name="city_text"
                              :disabled="disabled"
                              v-validate="'required'"
                              v-model="address.city_text"
                              class="mt-8 flex-auto p-1 w-full"/>
                    <ValidateText field="city_text" scope="address" :error="errors"/>
                </div>
            </template>
        </div>
        <div :class="classForDOM.parent">
            <div :class="classForDOM.block">
                <vs-input :label-placeholder="`${ $t('street') }`"
                          name="street"
                          :disabled="disabled"
                          v-model="address.street"
                          class="mt-8 flex-auto p-1 w-full"/>
            </div>
            <div :class="classForDOM.block">
                <vs-input :label-placeholder="`${ $t('home_number') }`"
                          name="home_number"
                          :disabled="disabled"
                          v-model="address.home_number"
                          class="mt-8 flex-auto p-1 w-full"/>
            </div>
            <div :class="classForDOM.block">
                <vs-input :label-placeholder="`${ $t('corpus') }`"
                          name="corpus"
                          :disabled="disabled"
                          v-model="address.corpus"
                          class="mt-8 flex-auto p-1 w-full"/>
            </div>
            <div :class="classForDOM.block">
                <vs-input :label-placeholder="`${ $t('apartment') }`"
                          name="apartment"
                          :disabled="disabled"
                          v-model="address.apartment"
                          class="mt-8 flex-auto p-1 w-full"/>
            </div>
            <div :class="classForDOM.block">
                <vs-input :label-placeholder="`${ $t('index') }`"
                          name="index"
                          :disabled="disabled"
                          v-model="address.index"
                          class="mt-8 flex-auto p-1 w-full"/>
            </div>
        </div>
    </form>
</template>

<script>
import MultiselectCustom from "@/pages/Home/Employment/components/MultiselectCustom";
import ValidateText from "@/pages/Home/FillingInTheApplicantsData/widgets/ValidateText";
export default {
    name: "AddressForm",
    components: {
        MultiselectCustom,
        ValidateText
    },
    props: {
        profileUid: {
            type: String,
            required: true,
        },
        typeUid: {
            type: String,
            required: true,
        },
        applicantNoProfileUid: {
            type: String,
            default: null,
        },
        data: {
            type: Object,
        },
        required: {
            type: Boolean,
            default: true,
        },
        name: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        address_errors: {
            type: Array,
        }
        // errors: {
        //     type: Array,
        //     default: null
        // }
    },
    data(){
        return {
            address: {
                type: this.typeUid,
                country: "",
                region: "",
                city: "",
                district: "",
                locality: "",
                street: "",
                home_number: "",
                corpus: "",
                apartment: "",
                index: "",
                city_text: "",
                profile:"",
                uid: null,
            },
            selectedKazakhstan: false,
            classForDOM: {
                grandParent: 'flex flex-col md:flex-row justify-between',
                parent: 'flex flex-col md:flex-row justify-between items-start',
                block: 'flex flex-col w-full',
            }
        }
    },
    computed: {
        getEndpointForGetCity(){
            return this.address.district
                ? `common/address-classifiers/?address_element_type=3&district=${ this.address.district.uid }`
                : `common/address-classifiers/?address_element_type=3&region=${ this.address.region?this.address.region.uid:this.address.region }`
        },
        select_kazakhstan(){
            if (this.address.country){
                if (this.address.country.code == 'KZ'){
                    return true
                }else{
                    return false
                }
            }

        }
    },

    methods: {
        setIfSelectedKazakhstan(value){
            this.address.country = value
            this.selectedKazakhstan = value.code === 'KZ';
            this.address.city_text = '';
        },
        clearDataForRegion(value){
            this.address.region = value
            this.address.district = '';
            this.address.locality = '';
            this.address.city = '';
        },
        clearDataForDistrict(value){
            this.address.district = value
            this.address.locality = '';
            this.address.city = '';
        },
        clearDataForLocality(value){
            this.address.locality = value;
            this.address.city = '';
        },
        clearDataCity(value){
            this.address.city = value;
        },
        async saveData(){
            this.$vs.loading();
            try {

                this.address.profile =  this.profileUid;
                await this.$http[await this.address.uid ? 'patch' : 'post'](
                    `admissions/addresses/${ this.address.uid ? this.address.uid + '/' : '' }`,
                    {
                        ...this.address,
                        ...(this.applicantNoProfileUid && {applicant: this.applicantNoProfileUid})
                    }
                );
                if(this.name)
                    await this.$emit('setData', { name: this.name, data: this.address })

            } catch (e){

            } finally {
                this.$vs.loading.close();

            }
        },
        getStatusHaveData(){
            let keys = Object.keys(this.address)
            keys = keys.filter(o => o !== 'profile' && o !== 'type'  && o !== 'uid')
            return keys.some(key => this.address[key])
        },
        validateStep(){
            if (this.name === 'temporal'){

                if (this.getStatusHaveData()){
                    return this.$validator.validateAll('address').then(async (result) => {
                        if (result) {
                            await this.saveData();
                            return true
                        }
                        else
                            return false

                    })
                } else {
                    return true
                }
            } else {
                return this.$validator.validateAll('address').then(async (result) => {
                    if (result) {
                        await this.saveData();
                        return true
                    }
                    else
                        return false

                })
            }
        }
    },
    created() {
        if (this.data){
            for(let key in this.address){
                if (this.data[key]){
                    if (key == 'country'||key == 'district'||key == 'locality'||key == 'region'||key == 'city'){
                        this.address[key] = this.data[key];
                    }else if(this.data[key].name){
                        this.address[key] = this.data[key].name;
                    }else{
                        this.address[key] = this.data[key];
                    }

                }
            }
            if (this.data.country == 'KZ'){
                this.selectedKazakhstan = true;
            }
        }
    },
    watch: {
        'address': {
            handler(val){
                this.$emit('setData', { name: this.name, data: this.getStatusHaveData() ? this.address : null })
            },
            deep: true
        },
        data: function(newVal, oldVal) {
            for(let key in this.address){
                if (this.data[key]){
                    if (key == 'country'||key == 'district'||key == 'locality'||key == 'region'||key == 'city'){
                        this.address[key] = this.data[key];
                    }else if(this.data[key].name){
                        this.address[key] = this.data[key].name;
                    }else{
                        this.address[key] = this.data[key];
                    }

                }
            }
            if (this.data['country_code'] && this.data['country_code'] === 'KZ'){
                this.selectedKazakhstan = true;
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>
